// src/components/Sidebar/index.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MdDashboard } from 'react-icons/md';
import { IoIosArrowForward } from 'react-icons/io';
import { FaAddressBook } from "react-icons/fa6";
import GroupsIcon from '@mui/icons-material/Groups';
import Button from '@mui/material/Button';
import { jwtDecode } from 'jwt-decode';

const Sidebar = () => {
  const token = localStorage.getItem('token');
  let decoded = null;
  if (token) {
    try {
      decoded = jwtDecode(token);
    } catch (err) {
      console.error('Invalid token', err);
    }
  }

  // SuperAdmin verification check
  const isSuperAdmin =
    decoded &&
    (decoded.role === 'superAdmin' ||
      decoded.empCode === '115061' ||
      decoded.empCode === '100124');

  const [activeTab, setActiveTab] = useState(0);
  const [isToggelSubmenu, setIsToggleSubmenu] = useState(false);

  const isOpenSubmenu = (index) => {
    if (activeTab === index) {
      setIsToggleSubmenu(!isToggelSubmenu);
    } else {
      setActiveTab(index);
      setIsToggleSubmenu(true);
    }
  };

  return (
    <>
      <div className='sidebar '>
        <ul>
          <li>
            <Link to="/dashboard">
              <Button className="w-100">
                <span className='icon'><MdDashboard /></span>
                Dashboard
              </Button>
            </Link>
          </li>
          <li>
            <Button className={`w-100 ${activeTab === 0 ? 'active' : ''}`} onClick={() => isOpenSubmenu(0)}>
              <span className='icon'><FaAddressBook /></span>
              Attendance
              <span className='arrow'><IoIosArrowForward /></span>
            </Button>
            <div className={`submenuWrapper ${activeTab === 0 && isToggelSubmenu === true ? 'open' : 'close'}`}>
              <ul className='submenu'>
                {/* {decoded?.role !== "User" && (
                  <li><Link to="/facescanner">Face Scanner</Link></li>
                )} */}
                <li><Link to="/attendancereport">Attendance Report</Link></li>
                {decoded?.role === "powerUser" && (
                  <div>
                    <li><Link to="/attendanceexport">Attendance Export</Link></li>
                    {/* <li><Link to="">Device Sync Logs</Link></li> */}
                    {/* <li><Link to="/devicestatus">Device Status</Link></li> */}
                  </div>
                )}
              </ul>
            </div>
          </li>
          <li>
            <Button className={`w-100 ${activeTab === 1 ? 'active' : ''}`} onClick={() => isOpenSubmenu(1)}>
              <span className='icon'><GroupsIcon /></span>
              HRM
              <span className='arrow'><IoIosArrowForward /></span>
            </Button>
            <div className={`submenuWrapper ${activeTab === 1 && isToggelSubmenu === true ? 'open' : 'close'}`}>
              <ul className='submenu'>
                <li><Link to="/odrecord">OD Records</Link></li>
                <li><Link to="/leaverecord">Leave Records</Link></li>
                {decoded?.role !== "User" && (
                  <div>
                    <li><Link to="/userdetails">User Details</Link></li>
                  </div>
                )}
                {decoded?.role === "powerUser" && (
                  <div>
                    <li><Link to="/register">User Registration</Link></li>
                    <li><Link to="/update">User Update</Link></li>
                    <li><Link to="/approvalrecords">Approval Records</Link></li>
                  </div>
                )}
                {isSuperAdmin && (
                  <li><Link to="/payroll">Payroll</Link></li>
                )}
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </>
  );
};

export default Sidebar;